<template>
  <div class="chart" v-if="nodes">
    <div class="chart__toolbar">
      <div class="buttons">
        <!-- <a @click.prevent="magnify" class="button">
          +
        </a>
        <a @click.prevent="fitSvg" class="button">
          -
        </a> -->
        <label for="only_non_voting" class="button">
          <span class="button__span">Only non-voting</span>
          <input type="checkbox" v-model="onlyNonVoting" id="only_non_voting"/>
        </label>
        <label for="show_all" class="button">
          <span class="button__span">Show all</span>
          <input type="checkbox" v-model="showAll" id="show_all"/>
        </label>
        <a @click.prevent="downloadAsPng" class="button">
          Save as image
        </a>
        <a @click.prevent="fitSvg" class="button">
          Fit
        </a>
      </div>
    </div>
    <svg width="100%" height="100%" class="chart-svg"
      preserveAspectRatio="xMinYMin meet"
      :viewBox="`0 0 600 550`">
      <diagram-legend x="0" y="20"/>
      <g :transform="groupTransformStr" class="svg__main-group">
        <!-- lines -->
        <path fill="none" stroke="#ccc" stroke-width="2px"
          v-for="(node, index) in nodes.slice(1)"
          :key="`link_${node.data.name}_${index}`"
          :d="calculatePath(node)"
        />
        <!-- list of directors -->
        <diagram-directors-list
          v-if="treeData.directors && treeData.directors.length > 0"
          :directors="treeData.directors"
          :nodes="nodes"/>
        <!-- nodes -->
        <diagram-node
          v-for="(node, index) in nodes"
          :node="node"
          :key="`node_${index}`"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import * as d3 from 'd3'
import DiagramNode from './DiagramNode'
import DiagramDirectorsList from './DiagramDirectorsList'
import DiagramLegend from './DiagramLegend'

export default {
  name: 'Diagram',
  props: ['treeData'],
  components: {
    DiagramNode,
    DiagramDirectorsList,
    DiagramLegend
  },
  data () {
    return {
      margin: {top: 50, right: 90, bottom: 50, left: 90},
      childKey: 'shareholders',
      onlyNonVoting: false,
      showAll: false
    }
  },
  mounted () {
    this.addSvgZoom()
  },
  computed: {
    treeWidth () {
      let levelWidth = [1]
      let childCount = (level, n, childKey) => {
        if (n[childKey] && n[childKey].length > 0) {
          if (levelWidth.length <= level + 1) levelWidth.push(0)

          levelWidth[level + 1] += n[childKey].length

          n[childKey].forEach(d => childCount(level + 1, d, childKey))
        }
      }
      childCount(0, this.$props.treeData, this.childKey)

      return d3.max(levelWidth) * 460
      // return this.width - this.margin.left - this.margin.right
    },
    treeHeight () {
      let levels = 0

      let levelCount = (n, childKey) => {
        if (n[childKey] && n[childKey].length > 0) {
          levels += 1
          n[childKey].forEach(d => levelCount(d, childKey))
        }
      }
      levelCount(this.$props.treeData, this.childKey)

      return levels * 270
      // return this.height - this.margin.top - this.margin.bottom
    },
    svgNode () {
      // return d3.select('svg').node()
      return document.querySelector('.chart-svg')
    },
    groupNode () {
      // return d3.select('svg').node()
      return document.querySelector('.svg__main-group')
    },
    svgWidth () {
      if (this.svgNode) {
        return this.svgNode.getBoundingClientRect().width
      }
    },
    svgHeight () {
      if (this.svgNode) {
        return this.svgNode.getBBox().height
      }
    },
    groupWidth () {
      if (this.groupNode) {
        return this.groupNode.getBBox().width
      }
    },
    groupTranslateX () {
      // return 0
      // if (this.svgNode) {
      //   return (this.svgWidth - this.margin.left - this.groupWidth) / 2
      // }
      // return (this.treeWidth) / 2
      return 0
    },
    groupTranslateY () {
      if (this.svgHeight) return this.svgHeight
      return this.treeHeight / 2
    },
    scaleFactor () {
      if (!this.svgNode || this.svgWidth > this.treeWidth) return 0.5
      if (this.treeWidth < this.treeHeight) {
        return (this.svgHeight / this.treeHeight * 2).toFixed(2)
      }
      return (this.svgWidth / this.treeWidth * 2).toFixed(2)
    },
    groupTransformStr () {
      // return `translate(${this.groupTranslateX},${this.groupTranslateY}) scale(${this.scaleFactor})`
      return `translate(100, 400) scale(0.5)`
    },
    nodes () {
      if (this.filteredTreeData) {
        const treemap = d3.tree().size([this.treeWidth, this.treeHeight])

        //  assigns the data to a hierarchy using parent-child relationships
        let nodes = d3.hierarchy(this.filteredTreeData, d => d[this.childKey])

        // maps the node data to the tree layout
        nodes = treemap(nodes)
        // nodes.descendants().forEach(function (d) { d.y = d.depth * 180 })

        return nodes.descendants()
      }
    },
    filteredTreeData () {
      let treeData = Object.assign({}, this.treeData)

      function copy (o) {
        return Object.assign({}, o)
      }

      const self = this

      if (!treeData.shareholders) treeData.shareholders = []

      treeData.shareholders = treeData.shareholders.map(copy).filter(function f (o) {
        if (self.showAll) return true
        // if (self.onlyNonVoting) return true
        if (o.isShareVoting && !self.onlyNonVoting) {
          if (o.shareholders) {
            o.shareholders = o.shareholders.map(copy).filter(f)
          }
          return true
        }

        if (!o.isShareVoting && self.onlyNonVoting) {
          return true
        }

        if (o.shareholders && o.shareholders.length > 0) {
          return (o.shareholders = o.shareholders.map(copy).filter(f)).length
        }
      })

      // console.log(treeData)
      return treeData
    }
  },
  methods: {
    // calc path for connections between nodes
    calculatePath (node) {
      return 'M' + node.parent.x + ',' + (-node.parent.y) +
        'V' + (-node.y + 200) + 'H' + node.x + 'V' + (-node.y)
    },
    // add zoom event listener
    addSvgZoom () {
      d3.select('.chart-svg').call(d3.zoom().on('zoom', _ => {
        const zoomX = this.groupTranslateX + d3.event.transform.x
        const zoomY = this.groupTranslateY + d3.event.transform.y
        const zoomK = d3.event.transform.k
        d3.select('.svg__main-group')
          .attr('transform', `translate(${zoomX},${zoomY}) scale(${zoomK})`)
      }))
    },
    // fit chart to div
    fitSvg () {
      d3.select('.chart-svg').call(
        d3.zoom().transform,
        // d3.zoomIdentity.scale(this.scaleFactor)
        d3.zoomIdentity.scale(0.5)
      )

      d3.select('.svg__main-group')
        .attr('transform', this.groupTransformStr)
    },
    // reset svg scale to 1
    resetScale () {
      d3.select('.chart-svg').call(
        d3.zoom().transform,
        d3.zoomIdentity.scale(1)
      )

      d3.select('.svg__main-group')
        .attr('transform',
          `translate(0,${this.treeHeight + this.margin.top}) scale(1)`)
    },
    downloadAsPng () {
      this.resetScale()

      // get actual svg size from main group
      // const svgGroup = d3.select('.svg__main-group')._groups[0][0]
      // const svgGroupSize = svgGroup.getBoundingClientRect()

      // get svg data
      const svgSource = d3.select('.chart-svg')._groups[0][0]
      const svg = svgSource.cloneNode(true)
      svg.removeAttribute('viewBox')
      const legend = svg.querySelector('.svg__legend-group')
      svg.removeChild(legend)
      const svgData = new XMLSerializer().serializeToString(svg)

      // create canvas
      const canvas = document.createElement('canvas')
      // canvas.width = svgGroupSize.width + this.margin.left + this.margin.right
      // canvas.height = svgGroupSize.height + this.margin.top + this.margin.bottom
      canvas.width = this.treeWidth + 2 * (this.margin.left + this.margin.right)
      canvas.height = this.treeHeight + 2 * (this.margin.top + this.margin.bottom)

      // img node to display on canvas
      const img = new Image()

      // event will be fired when image finished loading
      // and we can get data from it to convert to png
      img.onload = _ => {
        const ctx = canvas.getContext('2d')

        // white background for png
        ctx.fillStyle = 'rgb(255,255,255)'
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        // draw an image on canvas
        ctx.drawImage(img, this.margin.left * 2, 0, canvas.width, canvas.height)

        // convert canvas svg to png
        // change mime type to download image
        const data = canvas
          .toDataURL('image/png')
          .replace('image/png', 'image/octet-stream')

        // format name for file which will be downloaded
        const companyName = this.nodes[0].data.name
        const filename = companyName
          ? companyName.toLowerCase()
            .replace(/[/?<>\\:*|":&.'` ]/g, '_')
            .replace(/_+/g, '_') + '__chart.png'
          : 'organizational_chart.png'

        // initiate download
        const a = document.createElement('a')
        a.href = data
        a.download = filename
        a.click()
      }

      // setting the img source will initiate onload listener
      img.src = 'data:image/svg+xml;base64,' +
        window.btoa(unescape(encodeURIComponent(svgData)))
    }
  }
}
</script>

<style scoped>
.chart {
  width: 100%;
  text-align: center;
}

.chart__toolbar {
  position: relative;
  display: flex;
  justify-content: flex-end;
  top: 1em;
  margin-right: 0.5em;
}

.chart-svg {
  background: white;
  border: solid 1px #ccc;
  min-height: 550px;
  margin-top: -2em;
  cursor: pointer;
}

.button__span {
  margin-right: 0.5rem;
}

</style>
